import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

async function enableMocking() {
  // Only enable MSW if ENABLE_MOCK_API is true (controlled via .env)
  const enableMockApi = process.env.REACT_APP_ENABLE_MOCK_API === 'true';

  if (!enableMockApi) {
    return;
  }

  const { worker } = await import('./mocks/browser');

  // Start the worker with onUnhandledRequest set to 'bypass'
  // so that requests not handled by MSW pass through normally
  return worker.start({
    onUnhandledRequest: 'bypass',
  });
}

enableMocking().then(() => {
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
